import Store  from './../store'


export default {
    install: function(Vue, options){
        Vue.prototype.$isAuthorized = function(){
            return Store.getters.currentUser;
        };

        Vue.prototype.$isSuperAdmin = () => {
            let user = Store.getters.currentUser;
            return user && user.access_level === 'superadmin';
        };

        Vue.prototype.$isAdmin = () => {
            let user = Store.getters.currentUser;
            return user && ['admin', 'superadmin'].indexOf(user.access_level) >= 0;
        };

        // Vue.http.interceptors.response.push((request, next) => {
        //     console.log('ENTERING ROUTE');
        //     next()
        // });
    }
}


// WEBPACK FOOTER //
// ./src/plugins/auth.plugin.js